import './JobDescription.scss';

import { Tab, Tabs, Typography } from '@mui/material';
import { JobData, User } from 'components/JobQueue/utils';
import React, { useState } from 'react';
import { getAllListData } from 'services/CommonServices';
import { MASTER_ENDPOINT } from 'utils/Constant';

import Header from './Header';

interface JobDescriptionProps {
  jobSummary: string;
  // keyResponsibilities: string[];
  // requiredSkills: string[];
  jobData: JobData;
}

const JobDescription: React.FC<JobDescriptionProps> = ({
  jobData,
  jobSummary,
  // keyResponsibilities,
  // requiredSkills,
}) => {
  const [users, setUsers] = useState<User[]>([]);

  const [activeTab, setActiveTab] = useState(0);

  const userData = () => {
    getAllListData(
      `${MASTER_ENDPOINT.Admins}?sortby=name&order=ASC&roleId=5&search=&skip=&take=&organizationId=&status=true`,
    )
      .then((res) => {
        setUsers(res?.data);
      })
      .catch((err) => console.log({ err }));
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleBack = () => {
    // Navigate back to job queue
    console.log('Navigate back to job queue');
  };

  const handleCloseJob = () => {
    // Handle close job functionality
    console.log('Close job');
  };

  React.useEffect(() => {
    userData();
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        height: '100%',
      }}>
      {/* Header */}
      <Header
        jobTitle={jobData?.jobTitle || ''}
        company={jobData?.customer?.name || ''}
        location={`${jobData?.city || ''}, ${jobData?.state || ''}`}
        timePosted={jobData?.createdAt || ''}
        billRate={((): string => {
          const from = Number(jobData?.payRangeFrom);
          const to = Number(jobData?.payRangeTo);
          if (from > 0 && to > 0) {
            return `$${from} - $${to}`;
          } else if (from > 0) {
            return `$${from}`;
          } else if (to > 0) {
            return `$${to}`;
          } else {
            return '-';
          }
        })()}
        source={jobData?.jobSource || 'N/A'}
        assignedUsers={jobData?.usersAssigned || []}
        onBack={handleBack}
        onCloseJob={handleCloseJob}
        users={users}
        jobId={jobData?.id || ''}
        jobData={jobData}
      />
      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          '& .Mui-selected': {
            color: '#000000 !important',
          },
          '& .MuiTab-root': {
            color: '#000000',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '13px',
            fontWeight: '400',
            textTransform: 'none',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#ef4444',
          },
          borderBottom: '1px solid #e5e7eb',
          paddingLeft: '24px',
        }}>
        <Tab label="Job Description" />
      </Tabs>

      {/* Content */}
      <div
        style={{
          maxHeight: 'calc(100vh - 250px)',
          overflow: 'auto',
          padding: '12px 24px',
        }}>
        {/* Job Summary */}
        <div
          style={{ border: 'unset', marginBottom: '8px', padding: '0px' }}
          className="contain-box">
          <Typography
            component={'div'}
            className="contain-info wrapper-info"
            sx={{
              color: '#616161',
              fontFamily: 'Red Hat Display Regular',
              fontSize: '12px',
              paddingBottom: '8px',
              paddingLeft: '12px',
            }}
            dangerouslySetInnerHTML={{ __html: jobSummary }}
          />
        </div>

        {/* Information Cards */}
        <div
          style={{
            display: 'flex',
            gap: '16px',
            marginBottom: '24px',
          }}>
          {/* Pay Rate Card */}
          <div
            style={{
              background: 'rgba(253, 255, 249, 1)',
              backgroundColor: '#ffffff',
              borderBottom: '4px solid #40af7b',
              borderRadius: '8px',
              boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
              flex: 1,
              padding: '16px',
              textAlign: 'center',
            }}>
            <Typography
              sx={{
                color: '#111827',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                fontWeight: 500,
                marginBottom: '4px',
              }}>
              {((): string => {
                const from = Number(jobData?.payRangeFrom);
                const to = Number(jobData?.payRangeTo);
                if (from > 0 && to > 0) {
                  return `$${from} - $${to}`;
                } else if (from > 0) {
                  return `$${from}`;
                } else if (to > 0) {
                  return `$${to}`;
                } else {
                  return '-';
                }
              })()}
            </Typography>
            <Typography
              sx={{
                color: '#10b981',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '12px',
              }}>
              Pay Rate
            </Typography>
          </div>

          {/* Project Start Date Card */}
          <div
            style={{
              background: '#F8FCFF',
              backgroundColor: '#F8FCFF',
              borderBottom: '4px solid #2f8bbf',
              borderRadius: '8px',
              boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
              flex: 1,
              padding: '16px',
              textAlign: 'center',
            }}>
            <Typography
              sx={{
                color: '#111827',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                fontWeight: 500,
                marginBottom: '4px',
              }}>
              {jobData?.startDate
                ? new Date(jobData.startDate).toLocaleDateString()
                : '-'}
            </Typography>
            <Typography
              sx={{
                color: '#3b82f6',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '12px',
              }}>
              Project Start Date
            </Typography>
          </div>

          {/* Position Type Card */}
          <div
            style={{
              background: '#FCF9FF',
              backgroundColor: '#FCF9FF',
              borderBottom: '4px solid #943EDA',
              borderRadius: '8px',
              boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
              flex: 1,
              padding: '16px',
              textAlign: 'center',
            }}>
            <Typography
              sx={{
                color: '#111827',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                fontWeight: 500,
                marginBottom: '4px',
              }}>
              {jobData?.positionType || '-'}
            </Typography>
            <Typography
              sx={{
                color: '#a855f7',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '12px',
              }}>
              Position Type
            </Typography>
          </div>
        </div>

        {/* Job Details List */}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            padding: '16px',
          }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
            {/* Education */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Education
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.education || '-'}
              </Typography>
            </div>

            {/* Interview Type */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Interview Type
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.interviewType || '-'}
              </Typography>
            </div>

            {/* Duration */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Duration
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.jobDurationTo ? jobData?.jobDurationTo : '-'}
                {jobData?.jobDurationTo && jobData?.jobDurationTo === 24
                  ? '+'
                  : ''}
                {jobData?.jobDurationTo && ' Months'}
              </Typography>
            </div>

            {/* Location */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Location
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.workType === 'Remote'
                  ? 'Remote'
                  : jobData?.workType === 'Onsite'
                  ? 'Onsite'
                  : `${jobData?.city}, ${jobData?.state}`}
              </Typography>
            </div>

            {/* Work Status */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Work Status
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.jobWorkStatus
                  ?.map((ws) => ws?.workStatus?.name)
                  .join(', ') || '-'}
              </Typography>
            </div>

            {/* Certifications */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Certifications
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.certificates || '-'}
              </Typography>
            </div>

            {/* Sales Person */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Sales Person
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.user
                  ? `${jobData?.user?.firstName} ${jobData?.user?.lastName}`
                  : '-'}
              </Typography>
            </div>

            {/* Expected Resume Score */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              <Typography
                sx={{
                  color: '#616161',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  minWidth: '250px',
                }}>
                Expected Resume Score
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '14px',
                }}>
                {jobData?.expectedResumeScore || '-'}
              </Typography>
            </div>

            <Typography component={'div'} className="exp-tables">
              <table>
                <thead>
                  <tr>
                    <th
                      className="w-50"
                      style={{
                        paddingLeft: '4px',
                      }}>
                      Skills
                    </th>
                    <th className="w-25"># Yrs Required</th>
                    <th className="w-23">Preferred</th>
                  </tr>
                </thead>
                <tbody>
                  {jobData?.jobSkills &&
                    jobData?.jobSkills.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="w-50">{item?.skill?.name}</td>
                          <td
                            className="w-25"
                            style={{
                              textAlign: 'left',
                            }}>
                            {item?.required}
                          </td>
                          <td
                            className="w-23"
                            style={{
                              textAlign: 'left',
                            }}>
                            {item?.preffered}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDescription;
